import React, { Component } from 'react'

import cn from 'classnames'
import s from './LinedTable.scss'

export default class LinedTable extends Component {
  render() {
    const { className, children } = this.props
    return <div className={cn(s.table, className)}>{children}</div>
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Tables/LinedTable/LinedTable.jsx